var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.777 15.07h2.707V6.937H2.777v8.133zM5.66 4.43a1.385 1.385 0 0 0-.422-1.008c-.273-.266-.636-.399-1.09-.399-.453 0-.822.133-1.107.399a1.318 1.318 0 0 0-.428 1.008c0 .398.139.732.416 1.002.278.27.639.404 1.084.404h.012c.46 0 .832-.135 1.113-.404.282-.27.422-.604.422-1.002zm4.02 3.654v.037h-.024l.024-.037zm0 0V6.938H6.973c.023.515.023 3.226 0 8.132H9.68v-4.547c0-.296.027-.515.082-.656.117-.273.293-.506.527-.697.234-.191.523-.287.867-.287.907 0 1.36.613 1.36 1.84v4.347h2.707v-4.664c0-1.203-.285-2.113-.856-2.73-.57-.617-1.324-.926-2.262-.926-1.048 0-1.856.445-2.425 1.334zM18 3.375v11.25c0 .93-.33 1.725-.99 2.385a3.25 3.25 0 0 1-2.385.99H3.375a3.25 3.25 0 0 1-2.385-.99A3.25 3.25 0 0 1 0 14.625V3.375C0 2.445.33 1.65.99.99A3.25 3.25 0 0 1 3.375 0h11.25c.93 0 1.725.33 2.385.99.66.66.99 1.455.99 2.385z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.77a85c222dc6173ef2f4f6229d769014.svg";
export { ForwardRef as ReactComponent };